module.exports = __webpack_public_path__ + "static/mycatchme-dc2992da09d62a31cc87d0b6675859bc.png";